<template>
    <div>
        <div class="smallContent miscContent">
            <p v-if="$mq != 'sm'" id="title">
                Privacy Policy
                <br />
            </p>
            <p>
                We created this privacy policy statement in order to demonstrate
                our commitment to your privacy with respect to our website and
                services. This privacy policy explains our data collection and
                use practices as well as your choices regarding your personal
                information.
            </p>
            <br />
            <p>
                This Policy does not apply to information that you may provide
                to us, or that we may obtain through non-electronic means, such
                as via phone, by mail, or in person.
            </p>
            <p>
                Montez Press Radio believes in transparency when it comes to the
                collection of user data. We aim for this Policy to be simple,
                straightforward, and explicit about what information we collect
                and what we use it for. IF YOU DO NOT AGREE TO THIS PRIVACY
                POLICY YOU MAY NOT ACCESS OR OTHERWISE USE OUR WEBSITE.
            </p>
            <br />
            <p>What information does Montez Press Radio collect about me?</p>
            <br />
            <p>
                In simple terms, there are two categories of information Montez
                Press Radio may collect about you: user-provided information and
                site usage information.
            </p>
            <br />
            <p>
                User-provided information can be used to identify you as an
                individual. This includes names, physical/postal addresses,
                email addresses, and payment information. This information is
                only collected when you have consented to share it, typically
                when you:
            </p>
            <br />
            <p>· Donate or otherwise conduct a transaction online with us;</p>
            <p>· Create an account with us;</p>
            <p>· Subscribe to receive emails or newsletters from us;</p>
            <p>· Register to communicate on a forum with us; and</p>
            <p>· Submit comments or questions to us.</p>
            <br />
            <p>
                If you wish to opt out of any of these services you are free to
                do so at any time, primarily by closing any accounts you have
                established with us. For newsletters or other promotional
                communication, simply send us an email with the subject line
                “Unsubscribe” to
                <a href="mailto:support@montezpress.com"
                    >support@montezpress.com</a
                >. Please note that it may take us a few days to process your
                request, and that we may still contact you if you engage in
                non-promotional correspondence from us. Our servers
                automatically collect site usage information when you visit
                Montez Press Radio’s online platforms. This information includes
                your IP address (and the relevant domain name of which it is a
                part), the type of device you are using to connect to us,
                information about your browser and operating system settings,
                information about your usage behavior, such as how long you
                spend on our platforms, what you click on or download, search
                terms you use, and link-referral information.
            </p>
            <br />
            <p>
                We or our service providers and partners may also utilize common
                tracking technologies when you visit or interact with us,
                including cookies, pixel tags, and browser fingerprinting. We
                use cookies and other tracking technologies to collect
                information in order to improve our services for you. If you
                choose to later opt out of using cookies, you may always use the
                settings of your browser; however, this may negatively impact
                your experience on our website or your access to certain
                functionality.
            </p>
            <br />
            <p>
                MPR also has a presence on many third-party social networking
                and publishing platforms. Keep in mind that third party
                platforms have their own privacy policies, which we encourage
                you to examine for more information on how they collect data and
                what your choices are in regards to data collected about you.
                MPR may embed links or other content from third parties into our
                own online home. If you click on a third-party link, you will be
                directed to that third party website. We are not responsible for
                how these third parties may collect and utilize information
                about you if you interact with it. We strongly advise you to
                review the Privacy Policy of every site you visit and encourage
                you to read their privacy policies as well.
            </p>
            <br />
            <p>
                As an organization based in the United States, Montez Press
                Radio is beholden to U.S. law with regard to informational
                privacy and integrity.
            </p>
            <br />
            <p>
                How does Montez Press Radio use the information it collects
                about me?
            </p>
            <p>
                MPR uses your information to conduct the operations outlined
                above. We will never sell your information to any other party or
                service, though in some cases we may share your information with
                third parties who need it in order to provide services to us or
                on our behalf. In some cases, we may relate site usage
                information to user-provided information, primarily for the
                purposes of:
            </p>
            <br />
            <p>
                · Processing and fulfilling transactions, such as donations or
                purchases;
            </p>
            <p>
                · Site administration, including maintaining any accounts you
                establish with us;
            </p>
            <p>· Responding to questions and comments;</p>
            <p>· Developing new features and content; and</p>
            <p>· Protecting our own rights and property.</p>
            <br />
            <p>
                We may also share your information when we believe that
                disclosure is necessary to protect our own rights and property,
                your safety or the safety of others, or as necessary to comply
                with the law.
            </p>
            <br />
            <p>
                Finally, we may share site usage information (including
                aggregate data) with third parties for analytics services.
                Analytics is used to improve the user experience and to provide
                feedback on the demographic groups that are using our site and
                services.
            </p>
            <br />
            <p>
                How secure is my information on Montez Press Radio’s platforms?
            </p>
            <br />
            <p>
                We strive to protect the security and integrity of all
                user-provided information collected on MPR’s online platforms,
                but we cannot guarantee that your information will be absolutely
                safe during transmission or while stored on our system. If you
                correspond with us via email, you should be aware that your
                information is susceptible to interception by a third party
                while in transit. Montez Press Radio assumes no liability for
                the disclosure of your information due to errors or unauthorized
                acts by third parties during its transmission to us. You are
                responsible for maintaining the strict confidentiality of your
                account information, including passwords, and you are
                responsible for any activity that occurs on your account, even
                if you did not authorize it. If you believe that an account has
                been compromised, or you have any questions about our policy or
                security, please notify us immediately at
                <a href="mailto:support@montezpress.com"
                    >support@montezpress.com</a
                >. In the event we become aware of a data breach where your
                personal information has been disclosed to unrelated third
                parties, we will notify you within 72 hours of becoming aware of
                a breach if we think there is a reasonable risk of harm to you
                or if otherwise required to do so by law.
            </p>
            <br />
            <p>
                Please note that we will never contact you asking for any
                sensitive personal information such as your username or
                password. If you ever receive such a communication, it is most
                likely a phishing attack: please forward any such communication
                to us at
                <a href="mailto:support@montezpress.com"
                    >support@montezpress.com</a
                >
            </p>
            <br />
            <p>Miscellaneous</p>
            <br />
            <p>
                COPPA Compliance: The Montez Press Radio Privacy Policy does not
                apply to and is not directed at children under the age of 13.
                Children under the age of 13 are not authorized to utilize MPR’s
                online platforms. By using these platforms, you affirm that your
                age is 13 or older. If you believe that your child has submitted
                personal information to our website and you would like to
                request that such information be deleted, you may do so by
                emailing
                <a href="mailto:support@montezpress.com"
                    >support@montezpress.com</a
                >. You can learn more about COPPA at the United States Federal
                Trade Commission Website:
                <a
                    target="_blank"
                    href="https://www.ftc.gov/tips-advice/business-center/privacy-and-security/children%27s-privacy"
                    >https://www.ftc.gov/tips-advice/business-center/privacy-and-security/children%27s-privacy</a
                >
            </p>
            <br />
            <p>
                EU Residents (GDPR): We implement technical and organizational
                measures with respect to processing personal information from
                European Union individuals for purposes of the EU General Data
                Protection Regulation (“GDPR”). Upon request, we will provide
                you with information as to whether and what personal data we
                store in relation to you. Should your personal data be
                incorrect, you may request to have it rectified. We may collect
                and use your information on the basis of your consent. You may
                revoke your consent to use your personal data in the future, in
                whole or in part, or request deletion of your personal data.
                Please feel free to direct such requests, or other questions and
                comments regarding our GDPR compliance to
                <a href="mailto:support@montezpress.com"
                    >support@montezpress.com</a
                >.
            </p>
            <p>
                California Privacy Rights: Under the California “Shine the
                Light” law, California residents may opt-out of a company’s
                disclosure of personal information to third parties for its
                direct marketing purposes. As detailed above, you may choose to
                opt-out of our sharing of your personal information with third
                parties for marketing purposes at any time by submitting a
                request to
                <a href="mailto:support@montezpress.com"
                    >support@montezpress.com</a
                >. It is important to note that this opt-out does not prohibit
                disclosures made for non-marketing purposes.
            </p>
            <br />
            <p>What happens if this Privacy Policy is ever changed?</p>
            <br />
            <p>
                As new online technologies develop we may integrate them into
                our platforms and that may result in changes to the language of
                this Policy. When we do, we will post those changes on this page
                and update the effective date (found at the bottom) so that you
                have a way to always become aware of the information we collect,
                how we use it, and under what circumstances we disclose it. In
                some cases where material changes are made, we may proactively
                notify you of these changes, typically by sending you an email
                to the address we have on file for you. For all other changes,
                it is your responsibility to review this Privacy Policy
                frequently and remain informed about any changes to it, so we
                encourage you to visit this page often.
            </p>
            <p>
                Please contact us if you have any questions or comments
                regarding our privacy practices at
                <a href="mailto:support@montezpress.com"
                    >support@montezpress.com</a
                >
            </p>
            <br />
            <p>
                YOU UNDERSTAND AND AGREE THAT OUR LIABILITY FROM ANY DISPUTE
                OVER PRIVACY OR THIS PRIVACY POLICY WILL BE LIMITED AS SET FORTH
                IN THE TERMS AND CONDITIONS OF OUR APPLICABLE WEBSITE TERMS OF
                SERVICE, WHICH ARE INCORPORATED BY THIS REFERENCE.
            </p>
            <p>EFFECTIVE DATE: JANUARY 1, 2019</p>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Footer from "./Footer.vue";
export default {
    name: "Privacy",
    components: {
        Footer,
    },
};
</script>

<style scoped>
/* div { */
/*     width: calc(100% - 2rem); */
/* } */
/* @media only screen and (min-width: 1101px){ */
/* div { */
/*     width: calc(66% - 2rem); */
/* } */
/* } */
/* @media only screen and (min-width: 1440px){ */
/* div { */
/*     width: calc(50% - 2rem); */
/* } */
/* } */
/* @media only screen and (min-width: 1900px){ */
/* div { */
/*     width: calc(33% - 2rem); */
/* } */
/* } */
p {
    margin: 0;
}
p#title {
    margin-bottom: 1.3rem;
}
a {
    color: #aaaaaa;
    cursor: pointer;
}
a:hover {
    color: black;
}
input[type="submit"] {
    width: auto;
    border: none;
    color: #aaaaaa;
    padding: 0;
    display: inline;
    margin: 0;
}
input[type="submit"]:hover {
    color: black;
    background-color: transparent;
}

form {
    display: inline;
}
p.form {
    display: inline;
}
</style>
